import * as THREE from 'three';

/**
 * Generate a soft radial-gradient glow as a CanvasTexture.
 * Used as the visible sprite for discoverable / interactive stars.
 *
 * @param {string} color - rgb triple as comma-separated string (e.g., '255, 215, 120')
 * @param {number} size - canvas size in pixels
 * @returns {THREE.CanvasTexture}
 */
export function createGlowTexture(color = '255, 215, 120', size = 256) {
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = size;
  const ctx = canvas.getContext('2d');

  const gradient = ctx.createRadialGradient(
    size / 2, size / 2, 0,
    size / 2, size / 2, size / 2,
  );

  gradient.addColorStop(0.00, `rgba(${color}, 1.0)`);
  gradient.addColorStop(0.08, `rgba(${color}, 0.9)`);
  gradient.addColorStop(0.20, `rgba(${color}, 0.55)`);
  gradient.addColorStop(0.40, `rgba(${color}, 0.22)`);
  gradient.addColorStop(0.65, `rgba(${color}, 0.06)`);
  gradient.addColorStop(1.00, `rgba(${color}, 0.0)`);

  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, size, size);

  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  return texture;
}
